import { render, staticRenderFns } from "./SearchResultOpportunity.vue?vue&type=template&id=0063dfd8&"
import script from "./SearchResultOpportunity.vue?vue&type=script&lang=js&"
export * from "./SearchResultOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports